'use strict';
var wishlistHelper = require('base/product/wishlistHelper');

module.exports = {
    addToWishlist: function () {
        $('.add-to-wish-list').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var url = $this.data('href');
            var pid = $this.closest('.product-detail').find('.product-id').html();
            if (!url || !pid) {
                return;
            }
            wishlistHelper.wishListHandleClick($this, pid, url, $this, false, null)
        });
    }
};
